(function(){
    'use strict';

    if(detectIE()){
        $('body').addClass('ms-browser');
    }

    function detectIE() {
        // Internet Explorer 6-11
        if ((/*@cc_on!@*/false) || (document.documentMode)) {
            return true;
        }

        // Edge 20+
        if (!(document.documentMode) && window.StyleMedia) {
            return true;
        }

        return false;
    }

}());
